import { useMention } from "../context/MentionContext";

export const useMentionInput = () => {
  const { fetchSuggestions, registerInput, setActiveText, closeDropdown } =
    useMention();

  const getMentionChangeHandler = (value, setValue, inputRef) => (e) => {
    const text = e.target.value;

    setValue(text);
    setActiveText(text);

    if (inputRef?.current) {
      registerInput(text, setValue, inputRef.current);
    }

    const match = text.match(/(^|\s)@(\w*)$/);

    if (match) {
      fetchSuggestions(match[2]); // group without @
    } else {
      //close dropdown when @ is removed
      closeDropdown();
    }
  };

  return { getMentionChangeHandler };
};
